import {action, makeAutoObservable, observable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";

class ShowEditReferenceItemSalePriceStore {

    public salePriceId: string;
    public referenceItem: string;
    public value: number;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, salePriceId: string, referenceItemId: string, value: number) {
        this.loading = false;
        this.commonStore = commonStore;
        this.salePriceId = salePriceId;
        this.referenceItem = referenceItemId;
        this.value = value;
        this.isModalOpen = false;
        makeAutoObservable(this, {
            isModalOpen: observable
        });
    }

    @action
    public openModal(): void {
        this.isModalOpen = true;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async updateReferenceItemSalePrice() {
        const response = await SalePriceService.updateReferenceItemSalePrice(this.salePriceId, this.referenceItem, this.value);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default ShowEditReferenceItemSalePriceStore;